// extracted by mini-css-extract-plugin
export default {"modal":"expire-date-modal_modal__Lih4A"};